export default {
  floor: {
    addLayer: "Add",
    catalogLoadError: "Could not load floor type pool data.",
    catalogTitle: "Floor type pool",
    columns: {
      amount: "Amount",
      config: "Config",
      configStatus: "Configuration",
      mark: "Mark",
      totalArea: "Area (m²)",
      userDefinedType: "Type",
    },
    deleteSuccess: "Floor configuration removed.",
    description:
      "Configure floor types from the pool — click the settings icon to set the construction layers, U-value, and colour.",
    drawerTitle: "Floor configuration",
    floors: "floors",
    hasConfig: "Has config",
    layerColumns: {
      density: "Density (kg/m³)",
      heatCapacity: "Spec. heat (kJ/kg·K)",
      material: "Material",
      thermalConductivity: "λ (W/m·K)",
      thickness: "Thickness (m)",
    },
    layerFields: {
      density: "Density (kg/m³)",
      lambda: "λ (W/m·K)",
      material: "Material",
      specificHeat: "Spec. Heat (kJ/kg·K)",
      thickness: "Thickness (mm)",
    },
    layerLabel: "Layer",
    layers: "Layers",
    manageTypePools: "Manage floor types",
    noConfig: "Not configured",
    noLayers: "No layers yet. Add a layer or pick a floor type to define the construction.",
    poolColumns: {
      layers: "Layers",
      name: "Name",
      thicknessTotal: "Total thickness (m)",
      uValue: "U (W/m²K)",
    },
    removeConfig: "Remove config",
    saveSuccess: "Floor configuration saved.",
    selectType: "Select floor type…",
    title: "Floors setup",
    totalThicknessSuffix: "mm total",
    uValueText: "U = {{uValue}} W/m²K",
  },
  nav: {
    buildingAutomation: "building automation",
    buildingAutomationDetails: "building automation details",
    buildingAutomationFilesDownload: "Download building automation files",
    buildingEnvelope: "building envelope",
    coolingSystem: "cooling system",
    coolingSystemDetails: "cooling system details",
    coolingSystemFilesDownload: "Download cooling system files",
    energyMix: "Energy mix",
    energyMixDetails: "Energy mix details",
    energyMixFilesDownload: "Download energy mix files",
    energySupplySystem: "energy supply system",
    floor: "floor",
    floorDetails: "floor details",
    floorFilesDownload: "Download floor files",
    heatingSystem: "heating system",

    heatingSystemDetails: "heating system details",
    heatingSystemFilesDownload: "Download heating system files",
    hotWater: "hot water",
    hotWaterDetails: "hot water details",
    hotWaterFilesDownload: "Download hot water files",
    infiltration: "infiltration",
    infiltrationDetails: "infiltration details",
    infiltrationFilesDownload: "Download infiltration files",
    other: "other",
    pvSystem: "PV system",
    pvSystemDetails: "PV system details",
    pvSystemFilesDownload: "Download PV system files",
    rooftop: "rooftop",
    rooftopDetails: "rooftop details",
    rooftopFilesDownload: "Download rooftop files",
    room: "Room",
    roomConfiguration: "Room configuration",
    shadingSystem: "shading system",
    shadingSystemDetails: "shading system details",
    shadingSystemFilesDownload: "Download shading system files",
    ventilation: "Ventilation",
    ventilationDetails: "Ventilation details",
    ventilationFilesDownload: "Download ventilation files",
    wall: "wall",
    wallDetails: "wall details",
    wallFilesDownload: "Download wall files",

    windows: "windows",
    windowsDetails: "windows details",
    windowsFilesDownload: "Download windows files",
  },
  noInfoAvailable: "There is no information available!",
  rooftop: {
    addLayer: "Add",
    catalogLoadError: "Could not load rooftop type pool data.",
    catalogTitle: "Rooftop type pool",
    columns: {
      amount: "Amount",
      config: "Config",
      configStatus: "Configuration",
      mark: "Mark",
      totalArea: "Area (m²)",
      userDefinedType: "Type",
    },
    deleteSuccess: "Rooftop configuration removed.",
    description:
      "Configure rooftop types from the pool — click the settings icon to set the construction layers, U-value, and colour.",
    drawerTitle: "Rooftop configuration",
    hasConfig: "Has config",
    layerColumns: {
      density: "Density (kg/m³)",
      heatCapacity: "Spec. heat (kJ/kg·K)",
      material: "Material",
      thermalConductivity: "λ (W/m·K)",
      thickness: "Thickness (m)",
    },
    layerFields: {
      density: "Density (kg/m³)",
      lambda: "λ (W/m·K)",
      material: "Material",
      specificHeat: "Spec. Heat (kJ/kg·K)",
      thickness: "Thickness (mm)",
    },
    layerLabel: "Layer",
    layers: "Layers",
    manageTypePools: "Manage rooftop types",
    noConfig: "Not configured",
    noLayers: "No layers yet. Add a layer or pick a rooftop type to define the construction.",
    poolColumns: {
      layers: "Layers",
      name: "Name",
      thicknessTotal: "Total thickness (m)",
      uValue: "U (W/m²K)",
    },
    removeConfig: "Remove config",
    rooftops: "rooftops",
    saveSuccess: "Rooftop configuration saved.",
    selectType: "Select rooftop type…",
    title: "Rooftops setup",
    totalThicknessSuffix: "mm total",
    uValueText: "U = {{uValue}} W/m²K",
  },
  room: {
    addCatalogItem: "Add room type",
    addCatalogTitle: "Add room type — Pool configuration",
    catalogColumns: {
      hvac: "HVAC",
    },
    catalogTitle: "Room type pool",
    columns: {
      color: "Color",
      config: "Config",
      configStatus: "Configuration",
      functionKey: "Function key",
      roomCount: "Rooms",
      roomFunction: "Room function",
      roomTypeName: "Room type name",
      totalArea: "Area (m²)",
    },
    deleteError: "Could not remove room configuration.",
    deleteRow: "Delete configuration",
    deleteSuccess: "Room configuration removed.",
    description: "Select a room type to auto-fill its configuration. Edit any field in the panel on the right.",
    drawerTitle: "Room configuration",
    editConfig: "Edit configuration",
    fields: {
      airChangesPerHour: "Air changes per hour",
      catalogTemplate: "Catalog template",
      color: "Color",
      convectionFractionCooling: "Convection fraction (cooling)",
      convectionFractionHeating: "Convection fraction (heating)",
      coolingRanges: "Cooling ranges",
      coolingSetPoint: "Cooling set point (°C)",
      coolingSetPointCoolDown: "Cool-down set point (°C)",
      coolingSetPointExtreme: "Extreme cooling set point (°C)",
      coolingSetPointOffHours: "Off-hours cooling set point (°C)",
      coolingStart: "Cooling start",
      coolingSystem: "Cooling system",
      dinFunction: "DIN function",
      dynamicCoolingStartPointOffset: "Dynamic cooling start point offset",
      dynamicHeatingStartPointOffset: "Dynamic heating start point offset",
      equipmentFixedLoadPerM2: "Equipment fixed load (W/m²)",
      excessAirChangesPerHour: "Excess air changes per hour",
      group: "Group",
      heatingRanges: "Heating ranges",
      heatingSetPoint: "Heating set point (°C)",
      heatingSetPointOffHours: "Off-hours heating set point (°C)",
      heatingSetPointWarmUp: "Warm-up set point (°C)",
      heatingStart: "Heating start",
      heatingSystem: "Heating system",
      hvacEndCet: "HVAC end [CET]",
      hvacStartCet: "HVAC start [CET]",
      illuminationPerM2: "Illumination (W/m²)",
      m2PerPerson: "m² per person",
      roomCooling: "Room cooling",
      roomHeating: "Room heating",
      roomInfiltration: "Room infiltration",
      selectCoolingSystem: "Select cooling system…",
      selectHeatingSystem: "Select heating system…",
      selectVentilationType: "Select ventilation type…",
      tAirSupply: "Supply air temperature (°C)",
      tAirSupplyType: "Supply air temperature type",
      tAirSupplyTypeOptions: {
        from_file: "From file",
        static: "Static",
      },
      usageEndCet: "Usage end [CET]",
      usageSaturday: "Saturday",
      usageStartCet: "Usage start [CET]",
      usageSunday: "Sunday",
      ventilationPerArea: "Ventilation per area (m^3/(m^2.h))",
      ventilationType: "Ventilation type",
      ventilationTypeOptions: {
        mechanical: "Mechanical",
        natural: "Natural",
      },
    },
    hasConfig: "Has config",
    heatingForm: {
      add: "Add",
      control: {
        centralControl: "Central control",
        manual: "Manual",
        modelPredictive: "Model predictive",
        referenceRoom: "Reference room",
        temperatureBased: "Temperature based",
      },
      empty: "Add a heating system to configure it.",
      fields: {
        central: "Central",
        control: "Control",
        convection: "Convection %",
        heatExchange: "Heat exchange via",
        heatingRanges: "Heating ranges",
        radiation: "Radiation %",
        system: "Heating system",
      },
      heatExchange: {
        BKT: "Concrete Core activation (BKT)",
        ceiling_diffuser: "Ceiling diffuser",
        heater_not_under_window: "Heater not under window",
        heater_under_window: "Heater under Window",
      },
      sections: {
        setpoints: "Set points",
        systems: "Heating systems",
        usage: "Usage hours",
      },
      selectHeatExchange: "Select heat exchange…",
      selectSystem: "Select system…",
    },
    hotWaterForm: {
      fields: {
        active: "Active",
        hotWaterSystem: "Hot water system",
        litersPerDayPerM2: "Liters per day per m²",
        returnTemperature: "Return temperature (°C)",
        supplyTemperature: "Supply temperature (°C)",
      },
      selectSystem: "Select system…",
    },
    luminance: {
      control: {
        daylightControl: "Daylight control",
        manual: "Manual",
        onOff: "On Off",
        presenceDetection: "Presence Detection",
        schedule: "Schedule",
      },
      fields: {
        active: "Active",
        control: "Control",
        illuminationPerM2: "W_therm per W_el (illumination per m²)",
        investmentCostsPerM2: "€/m² Investment costs",
        investmentCostsPerWatt: "€/W Investment costs",
        luxPerM2: "LUX per m²",
        luxPerM2Hint: "not used yet",
        type: "Type",
        wElPerLux: "W_el per Lux",
      },
      mainTitle: "Main Luminance (Operating hours)",
      securityTitle: "Security Luminance",
      selectType: "Select type…",
    },
    manageRoomTypes: "Manage room types",
    noConfig: "No config",
    otherSections: {
      cooling: "Cooling",
      general: "General",
      heating: "Heating",
      hvac: "HVAC hours",
      occupancy: "Occupancy & loads",
      setpoints: "Set points",
      usage: "Usage hours",
      ventilation: "Ventilation",
    },
    removeConfig: "Remove config",
    rooms: "rooms",
    roomTypeNameRequired: "Room type name is required.",
    saveError: "Could not save room configuration.",
    saveSuccess: "Room configuration saved.",
    schedule: {
      airExchange: {
        operatingHours: "Standard Air Exchange rate operating hours",
        title: "Standard Air Exchange rate",
        unit: "air-changes-per-hour",
      },
      empty: "No schedule data available.",
      modes: {
        custom: "3-Custom",
        din: "2-DIN",
        realistic: "1-Realistic",
      },
      subtabs: {
        airExchange: "Air Exchange",
        appliances: "Internal Load",
        electricity: "Electricity",
        illuminance: "Illuminance",
        luminance: "Luminance",
        occupancy: "Usage",
        targetTemperature: "Target Temperature",
        ventilation: "Ventilation",
      },
      targetTemperature: {
        designTemperature: "DIN 12831 - Design Temperature",
        glidingTmax: "Tmax Y/N",
        glidingTmaxNight: "gliding Tmax Y/N",
        hintOffHours: "heating set point off-hours",
        hintOperatingGliding: "gliding cooling set point extreme",
        nightHours: "Night hours",
        nonOperatingDays: "Non operating days",
        operatingHours: "Operating hours",
        t: "T °C",
        title: "Target temperature",
        tMax: "Tmax °C",
        tMin: "Tmin °C",
      },
    },
    sections: {
      cooling: "Cooling",
      general: "General Info",
      heating: "Heating",
      hotWater: "Hot Water",
      loads: "Loads",
      luminance: "Luminance",
      other: "Other",
      schedules: "Schedules",
      ventilation: "Ventilation",
    },
    selectRoomType: "Select room type…",
    selectRoomTypeFirst: "Select a room type first",
    tabs: {
      cooling: "Cooling",
      general: "General Info",
      heating: "Heating",
      hotWater: "Hot Water",
      loads: "Loads",
      luminance: "Luminance",
      occupancy: "Occupancy",
      other: "Other",
      schedule: "Schedule",
      schedules: "Schedules",
      ventilation: "Ventilation",
    },
    title: "Room setup",
    ventilationForm: {
      control: {
        customized: "Customized",
        din18599: "DIN 18599 Standard",
        occupancyBased: "Occupancy Based",
      },
      fields: {
        airChangesPerHour: "Standard air exchange rate",
        considerInfiltration: "Consider infiltration as part of wanted air exchange rate",
        control: "Ventilation control",
        infiltrationAsWantedPercent: "Infiltration share %",
        infiltrationValue: "Infiltration value (h⁻¹)",
        mechanicalVentilationPercent: "Mechanical ventilation %",
        mechanicalVentilationSystem: "Mechanical ventilation system",
        naturalVentilationPercent: "Natural ventilation %",
        outdoorTDependent: "Outdoor temperature dependent natural ventilation",
        outdoorTPoint: "T{{index}} (°C)",
      },
      sections: {
        control: "Ventilation control",
        infiltration: "Infiltration",
        outdoorT: "Outdoor temperature dependent natural ventilation",
        setup: "Ventilation type",
        system: "Mechanical ventilation system",
      },
      selectSystem: "Select system…",
    },
  },
  scenario: {
    addScenario: "Add scenario",
    addTitle: "Add scenario",
    baselineDeleteError: "The default scenario cannot be deleted.",
    cardSubtitle: "Current building state",
    customSubtitle: "Custom scenario",
    deleteLastScenarioError: "At least one scenario must remain.",
    editTitle: "Edit scenario",
    fields: {
      dtLite: "DT Lite",
      heatRecoveryEfficiency: "Heat recovery efficiency",
      internalLoads: "Internal loads",
      name: "Name",
      occupancy: "Occupancy",
    },
    metrics: {
      dtLite: "DT Lite",
      heatRecoveryEfficiency: "Heat recovery efficiency",
      internalLoads: "Internal loads",
      occupancy: "Occupancy",
    },
    nameRequired: "Scenario name is required.",
    no: "No",
    yes: "Yes",
  },
  table: {
    columns: {
      area: "Area",
      Area: "Area",
      areaCovered: "Area covered",
      capacityPanel: "Capacity panel",
      co2_emissions_per_kwh: "CO2 emissions per kWh",
      color: "Color",
      Colour: "Colour",
      cop: "COP",
      cost_increase_per_year: "Cost increase per year",
      cost_per_kwh: "Cost per kWh",
      "Created at": "Created at",
      dcacInverterConfig: "DC/AC inverter config",
      decentralType: "Decentral type",
      Density: "Density",
      Description: "Description",
      description: "Description",
      distributionLosses: "Distribution losses",
      energySource: "Energy source",
      files: "files",
      Files: "Files",
      g_value: "G-Value",
      gValue: "G-Value",
      "Heat capacity": "Heat capacity",
      heatingSystem: "Heating system",
      Id: "Id",
      id: "Id",
      infiltration: "Infiltration",
      installationYear: "Installation year",
      Installed: "Installed",
      installed: "Installed",
      last_checked: "Last checked",
      lastChecked: "Last checked",
      Layer: "Layer",
      manufacturerName: "Manufacturer name",
      Modernization: "Modernization",
      modernization: "Modernization",
      monitoringInstalled: "Monitoring installed",
      number_of_windows: "Number of windows",
      numberOfWindows: "Number of windows",
      peakThermalPower: "Peak thermal power",
      storageLosses: "Storage losses",
      storageTemperature: "Storage temperature",
      storageVolume: "Storage volume",
      systemName: "System name",
      systemType: "System type",
      "Thermal conductivity": "Thermal conductivity",
      Thickness: "Thickness",
      thickness: "Thickness",
      u_value: "U-Value",
      "Updated at": "Updated at",
      utility_mix: "Utility mix",
      uValue: "U-Value",
      window_type: "Window type",
      windowType: "Window type",
    },
    title: {},
  },
  ventilation: {
    add: "Add",
    airCooling: {
      central: "Central",
      decentral: "Decentral",
      none: "NONE",
    },
    airHeating: {
      central: "Central",
      decentral: "Decentral",
      none: "NONE",
    },
    columns: {
      airSupplyMax: "Air supply Max m³/h",
      area: "Area m²",
      roomAmount: "Room amount",
      roomType: "Room type",
      ventilationControl: "Ventilation control/profile",
      volume: "Volume m³",
    },
    decentralHeating: {
      electric: "Electric Heating Register",
      gas: "Gas Based Heating Register",
    },
    description: "Define ventilation systems, the rooms they supply, and their technical settings.",
    empty: "Add a ventilation system to configure it.",
    fields: {
      airCooling: "Air cooling",
      airExhaust: "Air exhaust",
      airHeating: "Air heating",
      airSupply: "Air supply",
      coolingSystem: "Cooling system",
      dayNightFlushing: "Night flushing",
      decentralHeatingType: "Decentral heating",
      electricityDemand: "Electricity demand (kW/m³/s)",
      glidingMaximum: "Gliding maximum",
      glidingMaximumValue: "Gliding maximum (°C)",
      heatingSystem: "Heating system",
      heatRecovery: "Heat recovery",
      heatRecoveryEfficiency: "Heat recovery efficiency",
      localChiller: "Local chiller",
      nightFlushingBypass: "With bypass",
      peakCoolingLoad: "Peak cooling load (kW)",
      peakHeatingLoad: "Peak heating load (kW)",
      requiredTMax: "Maximum supply temperature (°C)",
      requiredTMin: "Minimum supply temperature (°C)",
    },
    localChillerNote: "Local chiller",
    selectCoolingSystem: "Select cooling system…",
    selectHeatingSystem: "Select heating system…",
    sum: "SUM",
    suppliedRooms: "Supplied rooms",
    systemName: "Ventilation {{index}}",
    title: "Ventilation",
  },
  wall: {
    addLayer: "Add",
    catalogLoadError: "Could not load wall type pool data.",
    catalogTitle: "Wall type pool",
    columns: {
      amount: "Amount",
      config: "Config",
      configStatus: "Configuration",
      mark: "Mark",
      totalArea: "Area (m²)",
      userDefinedType: "Type",
    },
    deleteSuccess: "Wall configuration removed.",
    description:
      "Configure wall types from the pool — click the settings icon to set the construction layers, U-value, and colour.",
    drawerTitle: "Wall configuration",
    fields: {
      color: "Colour",
    },
    geometry: {
      area: "Area (m²)",
      count: "Count",
      mark: "Mark",
    },
    hasConfig: "Has config",
    layerColumns: {
      density: "Density (kg/m³)",
      heatCapacity: "Spec. heat (kJ/kg·K)",
      material: "Material",
      thermalConductivity: "λ (W/m·K)",
      thickness: "Thickness (m)",
    },
    layerFields: {
      density: "Density (kg/m³)",
      lambda: "λ (W/m·K)",
      material: "Material",
      specificHeat: "Spec. Heat (kJ/kg·K)",
      thickness: "Thickness (mm)",
    },
    layerLabel: "Layer",
    layers: "Layers (inside → outside)",
    manageTypePools: "Manage wall types",
    noConfig: "Not configured",
    noLayers: "No layers yet. Add a layer or pick a wall type to define the construction.",
    poolColumns: {
      layers: "Layers",
      name: "Name",
      thicknessTotal: "Total thickness (m)",
      uValue: "U (W/m²K)",
    },
    removeConfig: "Remove config",
    saveSuccess: "Wall configuration saved.",
    selectType: "Select wall type…",
    tabs: {
      construction: "Construction",
      geometry: "Geometry",
    },
    title: "Walls setup",
    totalThicknessSuffix: "mm total",
    uValueText: "U = {{uValue}} W/m²K",
    uValueUnit: "W/m²K",
    walls: "walls",
  },
  windows: {
    addFrameType: "+ Add frame type",
    addFrameTypeTitle: "Add frame type",
    addShadingType: "+ Add shading type",
    addShadingTypeTitle: "Add shading type",
    addWindowType: "+ Add window type",
    addWindowTypeTitle: "Add window type",
    catalogLoadError: "Could not load type pool data.",
    catalogTitle: "Manage type pools",
    columns: {
      config: "Config",
      configStatus: "Configuration",
      frameType: "Frame type",
      shadingSystemType: "Shading type",
      surfaceCount: "Amount",
      totalArea: "Area (m²)",
      userDefinedType: "Type",
      windowTypeName: "Window type",
    },
    deleteSuccess: "Window configuration removed.",
    description:
      "Configure window types from the pool — click the settings icon to set window and frame type, shading, and other properties.",
    drawerTitle: "Window configuration",
    fields: {
      canBeOpened: "Can be opened",
      cdirThreshold: "C-dir threshold",
      controlLogicShadingDemand: "Shading demand control",
      controlLogicWindRisk: "Wind risk control",
      cutOffWindGust: "Cut-off wind gust",
      cutOffWindSpeed: "Cut-off wind speed",
      dirRadThreshold: "Direct radiation threshold (W/m²)",
      frameType: "Frame type",
      gValueDiffuseWindow: "g-dif",
      gValueDiffuseWindowShading: "g-dif (shading)",
      gValueDirectWindow: "g-dir",
      gValueDirectWindowShading: "g-dir (shading)",
      gValueWindow: "g",
      installationYear: "Installation year",
      maxWindAverage: "Max wind average",
      maxWindExtreme: "Max wind extreme",
      radiationTransitionDiffuse: "g-dif",
      radiationTransitionDirect: "g-dir",
      sfThreshold: "Sky fraction threshold",
      shadingLocation: "Shading location",
      shadingLocationNone: "none",
      shadingSystemDataCleared: "Shading system data is cleared",
      shadingSystemType: "Shading type",
      thermoautomatic: "Thermo-automatic",
      uValue: "U (W/m²K)",
      windowInfiltration: "Window infiltration",
      windowTypeName: "Window type",
    },
    hasConfig: "Has config",
    manageTypePools: "Manage type pools",
    noConfig: "Not configured",
    nonEmptyTypeAndFrame: "Window type and frame type are required.",
    poolColumns: {
      gFactor: "g-factor",
      gValueDiffuseWindow: "g-value-diffuse window",
      gValueDirectWindow: "g-value-direct window",
      infiltrationBase: "Infiltration base (m³/(h·m²))",
      location: "Location",
      maxWindAverage: "Max wind average [m/s]",
      maxWindExtreme: "Max wind extreme [m/s]",
      name: "Name",
      uValue: "U (W/m²K)",
      windAvg: "Wind avg",
      windExt: "Wind ext",
    },
    poolNameRequired: "Name is required.",
    poolSaveSuccess: "Type pool entry saved.",
    poolTabs: {
      shadingTypes: "Shading types",
      windowTypes: "Window types",
    },
    removeConfig: "Remove config",
    saveSuccess: "Window configuration saved.",
    selectFrameType: "Select frame type…",
    selectShadingType: "Select shading type…",
    selectWindowType: "Select window type…",
    tabs: {
      characteristics: "Characteristics",
      control: "Control logic",
      shading: "Shading",
    },
    title: "Windows setup",
    windows: "windows",
  },
};
